import type {Component, Editor} from 'grapesjs';
import {IconPlacement, Type} from '@Components/button/button';
import {copyComponentStyles, pasteComponentStyles} from '@EmailMakerReact/lib/email-maker-clipboard-library';
import type {CtaButtonGroupDescriptor} from './cta-button-control.types';

export const copyPasteStylesDescriptor: CtaButtonGroupDescriptor = {
  buttons: [
    {
      textKey: 'pmwjs_copy',
      iconClass: 'icon-copy-styles',
      type: Type.SECONDARY,
      iconPlacement: IconPlacement.LEFT,
      cb: (editor: Editor, _component: Component): void => {
        copyComponentStyles(editor);
      },
    },
    {
      textKey: 'pmwjs_paste',
      iconClass: 'icon-paste-styles',
      type: Type.SECONDARY,
      iconPlacement: IconPlacement.LEFT,
      disabledUntilStylesCopied: true,
      cb: (editor: Editor, component: Component): void => {
        pasteComponentStyles(editor, component);
      },
    },
  ],
};
